// Copyright (c) 2017 Deere & Company

import ReportLayoutColumnState from './report-layout-column-state';
import ReportLayoutSortModel from './report-layout-sort-model';
import t from 'tcomb';

const ReportLayout = t.struct({
    columnState: t.list(ReportLayoutColumnState, 'columnState'),
    filterModel: t.Object,
    isDefault: t.Bool,
    name: t.String,
    reportName: t.String,
    sortModel: t.list(ReportLayoutSortModel, 'sortModel')
}, {
    name: 'ReportLayout'
});

export const getDefaultState = () => new ReportLayout({
    columnState: [],
    filterModel: {},
    isDefault: false,
    name: '',
    reportName: '',
    sortModel: []
});

export default ReportLayout;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/report-layout.js